<template>
	<header class="page-header fixed-top">
		<b-navbar toggleable="lg" class="divide p-0" v-b-scrollspy="{offset: 100}">
			<b-container class="divider">
				<div class="brand-images-container position-relative">
					<b-navbar-brand href="#" v-scroll-to="'#app'" class="position-relative">
				  	<img src="../assets/img/purple-div.svg" class="position-absolute bg-img-header" alt="">
				  	<img src="../assets/img/logo.svg" class="logo" alt="Ahlstrom Munksjö">
				  </b-navbar-brand>
				</div>

				<b-navbar-toggle target="nav_collapse" title="menu">
					<span class="line d-block"></span>
					<span class="line d-block"></span>
					<span class="line d-block"></span>
				</b-navbar-toggle>

			  <b-collapse is-nav id="nav_collapse" class="position-relative" >
			    <b-navbar-nav class="ml-auto">
			      <b-nav-item href="#year" v-scroll-to="'#year'">The year</b-nav-item>
			      <b-nav-item href="#ceo" v-scroll-to="'#ceo'">CEO</b-nav-item>
			      <b-nav-item href="#company" v-scroll-to="'#company'">The Company</b-nav-item>
			      <b-nav-item href="#fiber" v-scroll-to="'#fiber'">Fiber</b-nav-item>
			      <b-nav-item href="#business" v-scroll-to="'#business'">Business areas</b-nav-item>
			      <b-nav-item href="#innovation" v-scroll-to="'#innovation'">Innovation</b-nav-item>
			      <b-nav-item href="#sustainability" v-scroll-to="'#sustainability'">Sustainability</b-nav-item>
			      <b-nav-item href="#financials" v-scroll-to="'#financials'">Financials</b-nav-item>
			    </b-navbar-nav>

			    <a 	:href="pdfLinks.full"
							class="header-download-link text-secondary font-weight-semi-bold"
							target="_blank">
						 Download Full Report 2017 <img src="../assets/img/icons/dl-orange.svg" width="15" height="16" class="icon">
					 </a>
			  </b-collapse>

			</b-container>
		</b-navbar>
	</header>
</template>
<script>
  import full from '../assets/pdf/full-report.pdf';

  export default {
    name: 'Header',
    data() {
      return {
        pdfLinks: {
          'full': full
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue